// extracted by mini-css-extract-plugin
export default {"educationL2":"EducationL2_educationL2__pO7wu","cards":"EducationL2_cards__XPpst","bigcard":"EducationL2_bigcard__GTAvL","map":"EducationL2_map__YRnjq"};